"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FARM_VERSION_TO_LEDGER_LAYOUT = exports.FARM_VERSION_TO_STATE_LAYOUT = exports.FARM_LEDGER_LAYOUT_V5_2 = exports.FARM_LEDGER_LAYOUT_V5_1 = exports.FARM_LEDGER_LAYOUT_V3_2 = exports.FARM_LEDGER_LAYOUT_V3_1 = exports.FARM_STATE_LAYOUT_V5 = exports.REAL_FARM_STATE_LAYOUT_V5 = exports.FARM_STATE_LAYOUT_V3 = void 0;
const marshmallow_1 = require("../marshmallow");
/* ================= state layouts ================= */
exports.FARM_STATE_LAYOUT_V3 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.u64)("nonce"),
    (0, marshmallow_1.publicKey)("lpVault"),
    (0, marshmallow_1.seq)((0, marshmallow_1.publicKey)(), 1, "rewardVaults"),
    (0, marshmallow_1.publicKey)(),
    (0, marshmallow_1.publicKey)(),
    (0, marshmallow_1.u64)(),
    (0, marshmallow_1.u64)(),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 1, "totalRewards"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u128)(), 1, "perShareRewards"),
    (0, marshmallow_1.u64)("lastSlot"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 1, "perSlotRewards"),
]);
exports.REAL_FARM_STATE_LAYOUT_V5 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.u64)("nonce"),
    (0, marshmallow_1.publicKey)("lpVault"),
    (0, marshmallow_1.publicKey)("rewardVaultA"),
    (0, marshmallow_1.u64)("totalRewardA"),
    (0, marshmallow_1.u128)("perShareRewardA"),
    (0, marshmallow_1.u64)("perSlotRewardA"),
    (0, marshmallow_1.u8)("option"),
    (0, marshmallow_1.publicKey)("rewardVaultB"),
    (0, marshmallow_1.blob)(7),
    (0, marshmallow_1.u64)("totalRewardB"),
    (0, marshmallow_1.u128)("perShareRewardB"),
    (0, marshmallow_1.u64)("perSlotRewardB"),
    (0, marshmallow_1.u64)("lastSlot"),
    (0, marshmallow_1.publicKey)(),
]);
exports.FARM_STATE_LAYOUT_V5 = new Proxy(exports.REAL_FARM_STATE_LAYOUT_V5, {
    get(target, p, receiver) {
        if (p === "decode")
            return (...decodeParams) => {
                const originalResult = target.decode(...decodeParams);
                return Object.assign(Object.assign({}, originalResult), { rewardVaults: [originalResult.rewardVaultA, originalResult.rewardVaultB], totalRewards: [originalResult.totalRewardA, originalResult.totalRewardB], perShareRewards: [originalResult.perShareRewardA, originalResult.perShareRewardB], perSlotRewards: [originalResult.perSlotRewardA, originalResult.perSlotRewardB] });
            };
        else
            return Reflect.get(target, p, receiver);
    },
});
/* ================= ledger layouts ================= */
exports.FARM_LEDGER_LAYOUT_V3_1 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.publicKey)("id"),
    (0, marshmallow_1.publicKey)("owner"),
    (0, marshmallow_1.u64)("deposited"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 1, "rewardDebts"),
]);
exports.FARM_LEDGER_LAYOUT_V3_2 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.publicKey)("id"),
    (0, marshmallow_1.publicKey)("owner"),
    (0, marshmallow_1.u64)("deposited"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u128)(), 1, "rewardDebts"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 17),
]);
exports.FARM_LEDGER_LAYOUT_V5_1 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.publicKey)("id"),
    (0, marshmallow_1.publicKey)("owner"),
    (0, marshmallow_1.u64)("deposited"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 2, "rewardDebts"),
]);
exports.FARM_LEDGER_LAYOUT_V5_2 = (0, marshmallow_1.struct)([
    (0, marshmallow_1.u64)("state"),
    (0, marshmallow_1.publicKey)("id"),
    (0, marshmallow_1.publicKey)("owner"),
    (0, marshmallow_1.u64)("deposited"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u128)(), 2, "rewardDebts"),
    (0, marshmallow_1.seq)((0, marshmallow_1.u64)(), 17),
]);
/* ================= index ================= */
// version => farm state layout
exports.FARM_VERSION_TO_STATE_LAYOUT = {
    3: exports.FARM_STATE_LAYOUT_V3,
    5: exports.FARM_STATE_LAYOUT_V5,
};
// version => farm ledger layout
exports.FARM_VERSION_TO_LEDGER_LAYOUT = {
    3: exports.FARM_LEDGER_LAYOUT_V3_2,
    5: exports.FARM_LEDGER_LAYOUT_V5_2,
};
//# sourceMappingURL=layout.js.map